module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("elZZb"))).then(() => parcelRequire('ikE14'));